// extracted by mini-css-extract-plugin
export default {"banner":"OnTimeBanner_banner__WINkL","banner_tips":"OnTimeBanner_banner_tips__bgAhh"};